<template lang="pug">
  div.verification-form(v-if="source")
    template(v-if="verificationType && verificationComponentName")
      //h3 {{verificationType}}
      slot(name="beforeForm" v-bind:source="source")
      component(:is="verificationComponentName" :source="source" ref="vfc"
        @verification-done="onDone" @verification-cancel="onCancel")
        template(v-slot:controlbuttons="{canCancel, cancelClass, nextClass, canContinue, goNext, clickCancel}" )
          //slot(name="controlbuttons")
          .form-group
            .input-controls.submit-buttons.grid-flex-buttons
              a.btn.btn-success-outline(href='#' :class="cancelClass" :disabled="!canCancel" @click.prevent="clickCancel") {{$t('Отмена')}}
              a.btn.btn-success(href='#' :class="nextClass" :disabled="!canContinue" @click.prevent="goNext") {{$t('Далее')}}
      slot(name="afterForm" v-bind:source="source")

</template>

<script lang="ts">
import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";
import type {VerificationSourceInterface} from "@/components/verification/verification";
const  TablecodeVerificationForm = () => import( "@/components/verification/TablecodeVerificationForm.vue");
const  SignatureVerificationForm = () => import( "@/components/verification/SignatureVerificationForm.vue");
const  PinVerificationForm = () => import( "@/components/verification/PinVerificationForm.vue");
const  SmsVerificationForm = () => import( "@/components/verification/SmsVerificationForm.vue");
const  GooglecodeVerificationForm = () => import( "@/components/verification/GooglecodeVerificationForm.vue");
import {VerificationTypes} from "@/models/verification/verification";

@Component({
  name: "VerificationForm",
  components: {
    TablecodeVerificationForm,
    SignatureVerificationForm,
    PinVerificationForm,
    SmsVerificationForm,
    GooglecodeVerificationForm
  }
})
export default class VerificationForm extends Vue {
  @Prop({required: true})
  source!: VerificationSourceInterface

  onCancel() {
    this.$emit('verification-cancel');
  }

  onDone() {
    this.$emit('verification-done');
  }

  //
  // get canContinue() {
  //   return this.$refs.vfc ? (this.$refs.vfc as AbstractVerificationForm).canContinue : false;
  // }
  // get canCancel() {
  //   return this.$refs.vfc ? (this.$refs.vfc as AbstractVerificationForm).canCancel : false;
  // }

  // clickCancel() {
  //   return (this.$refs.vfc as AbstractVerificationForm).clickCancel();
  // }
  //
  // goNext() {
  //   return (this.$refs.vfc as AbstractVerificationForm).goNext();
  // }

  // get nextClass() {
  //   return this.$refs.vfc ? (this.$refs.vfc as AbstractVerificationForm).nextClass : {};
  // }
  //
  // get cancelClass() {
  //   return  this.$refs.vfc ? (this.$refs.vfc as AbstractVerificationForm).cancelClass : {};
  // }

  get verificationComponentName(): string {
    const components = {
      [VerificationTypes.SMS]: 'sms-verification-form',
      [VerificationTypes.TABLECODE]: 'tablecode-verification-form',
      [VerificationTypes.CERTIFICATE]: 'signature-verification-form',
      [VerificationTypes.PIN]: 'pin-verification-form',
      [VerificationTypes.GOOGLECODE]: 'googlecode-verification-form',
    };

    return components[this.verificationType]
  }

  get verificationType() {
    return this.source.getVerificationType();
  }
}
</script>

<style scoped lang="less">
.verification-form {
  .submit-buttons {
    &.grid-flex-buttons {
      display: grid;
      grid-auto-flow: column;
      grid-gap: 25px;
      align-items: flex-start;
      justify-items: start;
      grid-template-columns: min-content;
    }
  }
  ::v-deep {
    .verification-form__body {

      //+ .verification-form__body {
      //  margin-bottom: 20px;
      //}

      .form-group {
        display: grid;
        grid-gap: 0 35px;
        grid-template-columns: repeat(12, [col-start] 1fr);// [labels] 30% [controls] 370px auto;
        grid-auto-flow: row;
        grid-auto-rows: auto;
        //margin-left: 20px;
        //margin-right: 20px;
        //width: 100%;
        justify-content: left;

        .help-block {
          font-size: 95%;
        }

        .form-control {
          width: 100%;
        }
        .input-controls {
          grid-column: col-start 5 / span 6;

        }

        + .form-group {
          margin-top: 15px;
        }

        .label-control {
          text-align: right;
          height: 48px;
          align-items: center;
          display: grid;
          //grid-area: labels;
          grid-column: col-start 1 / span 4;
        }
      }

      .control-label {
        margin: 0;
        position: relative;

        &.required {
          &:after {
            color: #ee4538;
            content: "*";
            position: absolute;
            right: -7px;
            top: 0;
          }
        }
      }
    }
  }
}

.submit-buttons {
  margin-top: 2em;
  display: grid;
  grid-template-columns: auto;
  grid-gap: 25px;
  grid-auto-flow: column;
}

</style>

<i18n>
{
  "en": {
    "Отмена": "Cancel",
    "Далее": "Next"
  }
}
</i18n>
